import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

import { computed } from 'vue'
import { getRelatedColors } from '../utils/colorUtils'


export default /*#__PURE__*/_defineComponent({
  props: {
  size: {
    type: [String, Number],
    default: 70,
  },
  absolute: Boolean,
  gap: {
    type: [String, Number],
    default: 2,
  },
  parentColor: {
    type: String,
    default: 'primary',
  },
  color: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props



// Return fixed color or calculated color based on parent color
const transitionColor = computed(() => {
  if (props.color) {
    return 'text-' + props.color
  }

  const color = props.parentColor
  const relatedColors = getRelatedColors(color)

  return relatedColors ? 'text-' + relatedColors.effectColor : `text-${color} opacity-60`
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-spinner", _unref(transitionColor)]),
    style: _normalizeStyle({
      width: __props.size + 'px',
      height: __props.size + 'px',
      position: __props.absolute ? 'absolute' : 'relative',
      gridGap: __props.gap + 'px',
    })
  }, _hoisted_10, 6))
}
}

})